export default __webpack_public_path__ + "svg/calendar/2025/1/marzo.svg?caa1e3b0";